import { LinkedRecord } from "./types";

const parseRequestIdFromLabel = (label: string): number | null => {
  const match = label.match(/Request\s*#(\d+)/i);
  return match ? Number(match[1]) : null;
};

export const getLinkedRecordPath = (
  linkedRecord: LinkedRecord | null | undefined
): string | null => {
  if (!linkedRecord) return null;

  const { type, id, label } = linkedRecord;

  switch (type) {
    case "request":
      return `/requests/${id}`;
    case "appointment": {
      const requestId = parseRequestIdFromLabel(label);
      if (requestId) return `/requests/${requestId}`;
      return null;
    }
    case "invoice":
      return `/invoices/${id}`;
    case "estimate":
      return `/estimates/${id}`;
    case "payment":
      return `/payments/${id}`;
    case "campaign":
      return `/outreach/campaigns/${id}/report`;
    case "service_plan":
      return `/admin/service-plans`;
    default:
      return null;
  }
};
